import { NodeData, PointProperty } from "./types"
import { v4 as uuidv4 } from "uuid"

export default class NodeDataLoader {
    static loadData(): NodeData {
        let rootNodeData: NodeData = {
            name: "Level 0 Node",
            id: uuidv4(),
            childNodes: [],
            properties: [],
        }

        let numNodes = 1

        const addChildNodes = (node: NodeData, level: number) => {
            let numChildren = Math.floor(Math.random() * 4)
            if (level === 1) {
                numChildren++
            }
            for (let i = 0; i < numChildren; i++) {
                const childNodeData: NodeData = {
                    name: "Level " + level + " Node",
                    id: uuidv4(),
                    childNodes: [],
                    properties: [],
                }

                const propCount = Math.floor(Math.random() * 7)
                for (let i = 0; i < propCount; i++) {
                    const pointProperty: PointProperty = {
                        name: "Property " + i,
                        value: Math.floor(Math.random() * 1000).toString(),
                        hasWarning: Math.random() > 0.9 ? true : false,
                    }
                    childNodeData.properties.push(pointProperty)
                }

                childNodeData.properties.sort((a, b) => (a.hasWarning > b.hasWarning ? -1 : 1))

                node.childNodes.push(childNodeData)
                numNodes++
                if (level < 5) {
                    addChildNodes(childNodeData, level + 1)
                }
            }
        }
        addChildNodes(rootNodeData, 1)

        console.log("numNodes = ", numNodes)
        // console.log(rootNodeData)

        return rootNodeData
    }
}
